/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Injectable } from '@angular/core';

import { Competition, Region } from '@cds/betting-offer/tags';
import { LeagueModel, RegionModel } from '@frontend/sports/betting-offer/feature/model';
import { RegionsConfig } from '@frontend/sports/common/client-config-data-access';
import { Nullable } from '@frontend/sports/common/core/utils/extended-types';
import { includes } from 'lodash-es';

@Injectable({
    providedIn: 'root',
})
export class RegionVisibilityService {
    constructor(private regionsConfig: RegionsConfig) {}

    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    shouldHide(region: Nullable<Region | RegionModel>, league: Nullable<LeagueModel | Competition>): boolean {
        const shouldHideRegion = includes(this.regionsConfig.listOfRegionsToHideRegionName, region?.id);
        const shouldHideRegionForLeague = includes(this.regionsConfig.listOfLeaguesToHideRegionName, league?.id);

        return shouldHideRegion && shouldHideRegionForLeague;
    }
}
